import { Navigate } from 'react-router-dom';
import { paths } from 'src/routes/paths';

/** Merged into redpacket-ledger-entries (user top / platform bottom). */
export default function SocialTradingRedpacketPlatformLedgerRedirect() {
  return <Navigate to={paths.socialTrading.redpacketLedgerEntries.root} replace />;
}
